import React from "react";
import { useTranslation } from "react-i18next";

export default function ConfirmOut({ }) {
  const { t } = useTranslation("clientLive");
    // const { id  } = useSelector((state) => state.user.user);

    return (
        <div>
            <div
                id="ConfirmOut"
                class="modal fade bd-example-modal-lg mt-5 preview-modal-availability"
                tabindex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                data-backdrop="static"
            >
                <div class="modal-dialog modal-lg modal-dialog-preview text-center">
                    <div class="modal-content p-5">
                        <h3>{t("backfill.confirmOut.title")}</h3>
                        <div id="msform">

                            <input
                                type="button"
                                name="Close"
                                class="next action-button m-3"
                                value={t("backfill.confirmOut.exit")}
                                onClick={() => window.loadModal2('#ConfirmOut', "hide")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
